/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import SortableContainer from "./SortableContainer";

class SortableGrid extends Component {
	constructor(props) {
		super(props);
		this.state = {
			items: props.children,
		};
	}

	createNew = e => {
		e.preventDefault();
		this.props.createNew();
	};

	render() {
		const { onSortEnd, shouldDisable, title } = this.props;

		return (
			<div>
				<div>
					<div className="btn-circle m-right" title="Add" onClick={this.createNew}>
						<i className="fal fa-plus icon"></i>
					</div>
					<h4 className="collection-title with-add">{title}</h4>
				</div>
				<SortableContainer shouldDisable={shouldDisable} onSortEnd={onSortEnd} useDragHandle={true}>
					{this.props.children}
				</SortableContainer>
			</div>
		);
	}
}

SortableGrid.propTypes = {
	onSortEnd: PropTypes.func,
	children: PropTypes.array,
	shouldDisable: PropTypes.bool,
	createNew: PropTypes.func,
	title: PropTypes.string,
};

export default SortableGrid;
